<template>
  <vs-dropdown vs-trigger-click class="flex justify-center items-center h-10 w-10 hover:bg-soft rounded cursor-pointer">
    <vs-icon :icon="icon" size="1.5rem" class="text-gray-dark"></vs-icon>

    <vs-dropdown-menu class="w-max">
      <slot />
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  name: 'MenuTrigger',
  props: {
    icon: {
      type: String,
      default: 'menu'
    }
  }
}
</script>
